import FetchFactory, {
	DeleteRequest,
	GetRequest,
	ModifyRequest
} from "utils/fetch/FetchRequest";

import { StatusType, Update } from "document/StatusTypes";
import { BlueprintInfo } from "./BlueprintService";
import { Import } from "./BlueprintTypes";

const ENDPOINT = "/api/blueprints";

export default class BlueprintClient {
	public static getAllWithStatus(
		status: StatusType
	): GetRequest<Array<BlueprintInfo>> {
		return FetchFactory.get(`${ENDPOINT}?status=${status}`);
	}

	public static updateStatus(
		id: number,
		data: Update
	): ModifyRequest<Update, void> {
		return {
			operation: "PUT",
			url: `${ENDPOINT}/${id}/status`,
			body: data,
			statusCode: 200,
			callback: () => Promise.resolve()
		};
	}

	public static delete(id: number): DeleteRequest<void> {
		return FetchFactory.del(`${ENDPOINT}/${id}`);
	}

	public static importFromLibrary(
		data: Import
	): ModifyRequest<Import, number> {
		return {
			operation: "POST",
			url: `${ENDPOINT}`,
			body: data,
			statusCode: 201,
			callback: response => {
				const location = response.headers.get("location");
				if (location === null) {
					return Promise.reject(new Error("Missing location header"));
				}
				return Promise.resolve(
					Number.parseInt(
						location.substring(location.lastIndexOf("/") + 1),
						10
					)
				);
			}
		};
	}

	public static updateFromLibrary(id: number): ModifyRequest<void, void> {
		return {
			operation: "PUT",
			url: `${ENDPOINT}/${id}/library`,
			body: undefined,
			statusCode: 204,
			callback: () => Promise.resolve()
		};
	}
}
